import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { formatPhone, formatPhoneDocumentation } from "../../../helpers/functions";
import { designationOptions } from "../../patient/create/options";
import { DataField, Divider, H2, P, Section } from "./common-components";

export const PrimaryHealthcareProvider = ({ formType, patient}) => {
  //  const { patient } = useContext(FormContextMA);
  const careProvider = patient.careProvider?.[0] || null;
  return (
    <Section className="space-y-[0.0833333in]" formType = {formType}>
      <H2>Primary Healthcare Provider</H2>
      {careProvider ? (
        <>
          <div className="grid grid-cols-1">
            <DataField
              label="Name"
              value={(
                (careProvider.firstName || "") +
                (careProvider.middleName ? ` ${careProvider.middleName}` : "") +
                (careProvider.lastName ? ` ${careProvider.lastName}` : "")
              ).trim()}
            />
          </div>
          <div className="grid grid-cols-2">
            <DataField
              label="License Number"
              value={careProvider.licenseNumber}
            />
            <DataField
              label="Designation"
              value={
                designationOptions.find((d) => d.value === careProvider.title)
                  ?.label
              }
            />
          </div>
          <Divider />
          <div className="grid grid-cols-2">
            <DataField
              label="Phone"
              value={
                careProvider.contactInfo?.primaryPhone
                  ? formatPhoneDocumentation(careProvider.contactInfo.primaryPhone)
                  : ""
              }
            />
            <DataField label="Fax" value={formatPhoneDocumentation(careProvider.contactInfo?.fax)} />
          </div>
          <div className="grid grid-cols-2">
            <DataField
              label="Email Address"
              value={careProvider?.contactInfo?.email}
            />
          </div>
        </>
      ) : (
        <P className="font-semibold">No Primary Healthcare Provider</P>
      )}
    </Section>
  );
};
